import { useEffect, useState } from 'react';
import { usePageTitle } from '../../hooks/usePageTitle';
import SideBar from '../../components/global/SideBar';
import './index.css';
import SpecialistPage from '../../components/specialists/SpecialistPage';
import type { PartnerResponse } from '../../services/schedule.service';
import { fetchPartnersOfType } from '../../services/specialist.service';
import { Loader } from '@beholos/holoscommon';

export default function Nutrition() {
  usePageTitle('Nutrición - Holos');
  const [partners, setPartners] = useState<PartnerResponse[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      setPartners(await fetchPartnersOfType('showNutritionist'));
      setLoading(false);
    }
    fetchData();
  }, [])

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto">
        {loading ? <Loader /> : <SpecialistPage
          bannerClassName="md:min-h-[auto] min-h-[calc(100vh-80px)]"
          banner={{
            title: 'Asesorías Nutricionales 100% personalizadas',
            subtitle:
              'Agenda una sesión nutricional virtual 100% personalizada con nuestros profesionales expertos y obtén la guía que necesitas. *Incluye plan alimenticio mensual.',
            imageUrl:
              'https://image.beholos.com/fit-in/1500x700/filters:quality(50)/img/fitness-pass-v2/banners/nutritionist-banner2.jpg',
            links: {
              text: 'Ver Horarios y Citas',
              to: 'reservar',
            },
          }}
          section={{
            title: 'Conoce a nuestros Nutricionistas Calificados',
            description:
              'Cada profesional es especialista en su rama. Elige el de tu preferencia, pues te ayudarán a cumplir tus metas de manera segura y óptima. Se enviará un plan de nutrición, como máximo 48 horas después de terminar la sesión. Este plan llegará por correo electrónico o el medio que le funcione mejor al profesional y al usuario.',
          }}
          specialists={partners.map(partner => ({
            id: partner._id,
            name: partner.name,
            slug: partner.slug,
            imageUrl: `https://image.beholos.com/600x500/filters:quality(90)${partner.otherStudioImages[0]}`,
            countryImageUrl: `https://cache.beholos.com${partner.country?.image}`,
            type: 'Nutritionista'
          }))}
          article={{
            title: 'Visita el Blog - Aprende de Nutrición',
            subTitle: 'Tips y cientos de recetas saludables.'
          }}
        />}
      </div>
    </div>
  );
}
